import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {GameFeaturesTableComponent} from './features/table/game-features-table.component';
import {GameAboutComponent} from './about/game-about.component';
import {GameJackpotPreviewComponent} from './jackpot/game-jackpot-preview.component';
import {Check} from "@sparkware/app-utils";
import {GameInfo} from '../../../../services/games/game-info';
import {GamePreviewInfoContainerBox} from './game-preview-info-container.box';
//import {RelatedGamesComponent} from './related-games/related-games.component';

export interface GameInfoWrapperComponentProps {
  gameInfo: GameInfo;
  gameTitleComponent: React.ReactNode | null;
}
export class GamePreviewInfoContainerComponent extends OrbitComponent<GameInfoWrapperComponentProps> {

  private _renderJackpotPreview(gameInfo) {

    if(!gameInfo.hasJackpot){
      return null;
    }

    let generalSettings = this.services.configuration.data.generalSettings;

    let shouldRenderJackpotPreview = generalSettings?.gamesPreviewConfig?.shouldDisplayJackpot;

    if (Check.isNullOrUndefined(shouldRenderJackpotPreview) || shouldRenderJackpotPreview)
    {
      return <GameJackpotPreviewComponent gameType={gameInfo.gameType}/>;
    }

    return null;
  }

  render() {
    let gameInfo = this.props.gameInfo;

    return (
      <GamePreviewInfoContainerBox className='cy-game-preview-info-container'>
        {this.props.gameTitleComponent}
        <GameFeaturesTableComponent features={this.services.gamePreviewFeaturesSelector.getPreviewFeatures(gameInfo)} />
        <GameAboutComponent aboutText={gameInfo.aboutText}/>
        {this._renderJackpotPreview(gameInfo)}
        {/*<RelatedGamesComponent />*/}
      </GamePreviewInfoContainerBox>
    );
  }
}

